import type { CSSProperties } from 'react';

/* The women's-health bloom, from the Powerplugs design file (5285:30312).
 *
 * Not a Phosphor icon. The set ships Flower, FlowerTulip and FlowerLotus, and
 * none of them is this glyph — Phosphor's Flower is six rounded lobes built
 * from overlapping circles, where this is seven pointed petals meeting at a
 * point. Close enough to look like a substitution mistake, far enough that it
 * would be one.
 *
 * Drawn rather than shipped as a file so it takes `currentColor` like every
 * other icon in the row, and so it cannot go missing from the build. The
 * export repeats one petal with six <use> transforms; each is a rotation about
 * the 30x30 centre by a multiple of 360/7, so the petals are emitted directly
 * here instead — same geometry, no xlink fragment ids to collide when the icon
 * renders more than once on a page. */

const PETAL =
  'M15.7411 1.96261C15.3318 1.55331 14.6682 1.55323 14.2589 1.96251C11.394 ' +
  '4.82746 11.3942 9.47301 14.259 12.3381C14.6683 12.7474 15.3319 12.7475 ' +
  '15.7412 12.3382C18.6061 9.47329 18.6059 4.82774 15.7411 1.96261Z';

const PETALS = 7;

export interface FlowerBloomIconProps {
  size?: number | string;
  /* Accepted and ignored. Every icon in the row is called with a Phosphor
     weight; this one has a single drawn form, and dropping the prop at one
     call site would make the row read as if the icons were unrelated. */
  weight?: string;
  color?: string;
  className?: string;
  style?: CSSProperties;
}

export const FlowerBloomIcon = ({
  size = 24,
  color = 'currentColor',
  className,
  style,
}: FlowerBloomIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    aria-hidden="true"
    focusable="false"
  >
    {Array.from({ length: PETALS }, (_, i) => (
      <path
        key={i}
        d={PETAL}
        fill={color}
        transform={i === 0 ? undefined : `rotate(${(360 / PETALS) * i} 15 15)`}
      />
    ))}
  </svg>
);

export default FlowerBloomIcon;
